module.exports = __webpack_public_path__ + "static/media/MHHlong.ee6d7d16.png";